import {
  formatGraphQLError,
  formatServerError,
  pageInfo,
  parseData,
} from "../../utils/helper";
import {
  FETCH_DATA_SUCCESS,
  FETCH_VERIFICATION_CODE_SUCCESS,
  CLEAN_VERIFICATION_CODE,
  FETCH_GUARDIAN_SUCCESS,
  FETCH_LATEST_ACTIVE_INSUREE_FAILURE,
  FETCH_LATEST_ACTIVE_INSUREE_REQUEST,
  FETCH_LATEST_ACTIVE_INSUREE_SUCCESS,
  FETCH_POLICIES_INSUREE_FAILURE,
  FETCH_POLICIES_INSUREE_REQUEST,
  FETCH_POLICIES_INSUREE_SUCCESS,
  FETCH_HEALTH_FACILITIES_SUCCESS,
  FETCH_VERIFICATION_DATA_SUCCESS,
  FETCH_HEALTH_FACILITIES_INUSREE_SUCCESS,
  FETCH_HEALTH_FACILITIES_INUSREE_STATUS_SUCCESS,
  FETCH_VERIFICATION_HISTORY_SUCCESS,
  FETCH_PRINT_CARE_SHEET_SUCCESS,
  CREATE_FOSA_USER_SUCCESS,
  FETCH_CLAIM_TABLE_SUCCESS,
  FETCH_CLAIM_SERVICE_SUCCESS,
  FETCH_CLAIM_ITEMS_SUCCESS,
  FETCH_PATHOLOGY_SUCCESS,
  CORE_MUTATION_RESP,
  FETCH_CLAIMBYID_SUCCESS,
  FETCH_CLAIMHISTORYBYID_SUCCESS,
  FETCH_ADMINID_SUCCESS,
  FETCH_INSUREEUUID_SUCCESS,
  SUBMIT_CLAIM_SUCCESS,
  CREATE_ATTACHMENT_SUCCESS,
  FETCH_ATTACHEMENTS_SUCCESS,
  FETCH_MEDICAL_INSUREE_SUCCESS,
  GET_CONSULTANT_SUCCESS,
  FETCH_FOSA_USER_SUCCESS,
  CLEAR_CARESHEET_DATA,
  CLEAR_CLAIM_RESP,
  FETCH_PREAUTH_SUCCESS,
  FETCH_PREAUTHFORM_SUCCESS,
  GET_PREAUTH_SUCCESS,
  FETCH_PREAUTH_HISTORY_SUCCESS,
  FETCH_ADMIN_TABLE_REQUEST,
  FETCH_ADMIN_TABLE_SUCCESS,
  FETCH_ADMIN_TABLE_FAILURE,
  CREATE_ADMIN_REQUEST,
  CREATE_ADMIN_SUCCESS,
  CREATE_ADMIN_FAILURE,
  FETCH_ADMIN_REQUEST,
  FETCH_ADMIN_SUCCESS,
  FETCH_ADMIN_FAILURE,
  EDIT_ADMIN_REQUEST,
  EDIT_ADMIN_SUCCESS,
  EDIT_ADMIN_FAILURE,
  DELETE_ADMIN_REQUEST,
  DELETE_ADMIN_SUCCESS,
  DELETE_ADMIN_FAILURE,
  FETCH_ROLES_REQUEST,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAILURE,
  FETCH_FOSA_USER_REQUEST,
  FETCH_FOSA_MEDICAL_ITEMS_FAILURE,
  FETCH_FOSA_MEDICAL_ITEMS_SUCCESS,
  FETCH_FOSA_MEDICAL_ITEMS_REQUEST,
  FETCH_FOSA_MEDICAL_SERVICES_REQUEST,
  FETCH_FOSA_MEDICAL_SERVICES_SUCCESS,
  FETCH_FOSA_MEDICAL_SERVICES_FAILURE,
  FETCH_SUBSTITUTE_SUCCESS,
  FETCH_HEALTH_FACILITIES_SUBSTITUTE_STATUS_SUCCESS,
  FETCH_CONVENTIONNEMENT_BY_HF_ID_SUCCESS,
  FETCH_HEALTH_FACILITIES_PACKAGE_REQUEST,
  FETCH_HEALTH_FACILITIES_PACKAGE_SUCCESS,
  FETCH_HEALTH_FACILITIES_PACKAGE_FAILURE,
  FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_REQUEST,
  FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_SUCCESS,
  FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_FAILURE,
  FETCH_CLAIM_CHAT_REQUEST,
  FETCH_CLAIM_CHAT_SUCCESS,
  FETCH_CLAIM_CHAT_FAILURE,
} from "../actions/types";
import _ from "lodash";

const initialState = {
  signUpResponseData: null,
  fetchingSignUp: false,
  fetchedSignUp: false,
  errorSignUp: null,
  // for verification
  fetchingVerificationData: false,
  fetchedVerificationData: false,
  errorPickerVerificationInsurees: null,
  pickerVerificationInsurees: [],
  pickerVerificationInsureesPageInfo: {},
  pickerVerificationInsureesTotalCount: 0,

  fetchingVerificationCode: false,
  fetchedVerificationCode: false,
  errorVerificationCode: null,
  VerificationCode: [],
  //for health facility
  fetchingHealthFacilityData: false,
  fetchedHealthFacilityData: false,
  // errorPickerVerificationInsurees: null,
  pickerHealthFacilityInsurees: [],

  fetchingConventionnementData: false,
  fetchedConventionnementData: false,
  Conventionnement: [],
  errorConventionnement: null,

  fetchingHealthFacilitiesPackageData: false,
  fetchedHealthFacilitiesPackageData: false,
  healthFacilitiesPackageData: null,
  healthFacilityHealthSupport: null,
  errorHealthFacilitiesPackageData: null,
  healthFacilitiesPackageDataPageInfo: { totalCount: 0 },

  fetchingHealthFacilitiesProductBundleData: false,
  fetchedHealthFacilitiesProductBundleData: false,
  healthFacilitiesProductBundleData: null,
  errorHealthFacilitiesProductBundleData: null,
  healthFacilitiesProductBundleDataPageInfo: { totalCount: 0 },

  fetchingHfInsuree: false,
  fetchedHfInsuree: false,
  HfInsuree: [],
  errorHfInsuree: null,

  fetchingHfInsureeStatus: false,
  fetchedHfInsureeStatus: false,
  HfInsureeStatus: [],
  errorHfInsureeStatus: null,

  fetchingHfSubstituteStatus: false,
  fetchedHfSubstituteStatus: false,
  HfSubstituteStatus: [],
  errorHfSubstituteStatus: null,

  fetchingVerificationHistory: false,
  fetchedVerificationHistory: false,
  verificationHistoryData: null,
  verificationHistoryPageInfo: { totalCount: 0 },
  errorVerificationHistory: null,

  fetchingPolicies: false,
  fetchedPolicies: false,
  errorPolicies: null,
  policies: null,
  policiesPageInfo: { totalCount: 0 },

  fetchingPolicyValid: false,
  fetchedPolicyValid: false,
  policyValidData: null,
  errorPolicyValid: null,

  fetchingGuardian: false,
  fetchedGuardian: false,
  guardianData: null,
  errorGuardian: null,    

  fetchingCareSheet: false,
  fetchedCareSheet: false,
  careSheetData: null,
  errorCareSheet: null,

  createFosaUserData: null,
  fetchingFosaUser: false,
  fetchedFosaUser: false,
  errorFosaUser: null,
  // CLaim table
  fetchingClaimTableData: false,
  fetchedClaimTableData: false,
  errorClaimTableData: null,
  ClaimTableData: [],
  ClaimTableDataPageInfo: { totalCount: 0 },

  fetchingClaimServices: false,
  fetchedClaimServices: false,
  errorClaimServices: null,
  ClaimServices: null,
  ClaimServicesPageInfo: { totalCount: 0 },

  fetchingClaimItems: false,
  fetchedClaimItems: false,
  errorClaimItems: null,
  ClaimItems: [],
  ClaimItemsPageInfo: { totalCount: 0 },

  // Pathology
  fetchingPathology: false,
  fetchedPathology: false,
  pathalogyList: [],
  errorpathalogy1List: null,

  fetchingClaimById: false,
  fetchedClaimById: false,
  ClaimByIdData: null,
  ClaimByIdPageInfo: { totalCount: 0 },
  errorClaimById: null,

  fetchingClaimHistoryById: false,
  fetchedClaimHistoryById: false,
  ClaimHistoryByIdData: null,
  errorClaimHistoryById: null,

  fetchingAdminId: false,
  fetchedAdminId: false,
  AdminIdData: null,
  AdminIdPageInfo: { totalCount: 0 },
  errorAdminId: null,

  fetchingInsureeUuid: false,
  fetchedInsureeUuid: false,
  InsureeUuidData: null,
  InsureeUuidPageInfo: { totalCount: 0 },
  errorInsureeUuid: null,

  fetchingSubstitute: false,
  fetchedSubstitute: false,
  errorSubstitute: null,
  SubstituteData: null,

  claimUpdate: null,
  fetchingclaimUpdate: false,
  fetchedclaimUpdate: false,
  errorclaimUpdate: null,

  claimAttachments: null,
  fetchingclaimAttachments: false,
  fetchedclaimAttachments: false,
  errorclaimAttachments: null,

  fetchingAttachments: false,
  fetchedAttachments: false,
  AttachmentsData: null,
  AttachmentsPageInfo: { totalCount: 0 },
  errorAttachments: null,

  fetchingMutations: false,
  mutations: null,

  medicalInsureeResponseData: null,
  medicalInsureePageInfo: {},
  fetchingMedicalInsuree: false,
  fetchedMedicalInsuree: false,
  errorMedicalInsuree: null,

  getConsultantData: null,
  getConsultantDataPageInfo: {},
  fetchingConsultantData: false,
  fetchedConsultantData: false,
  errorConsultantData: null,

  // fetchingFosaUser: false,
  // fetchedFosaUser: false,
  fosaUserData: null,
  fosaUserPageInfo: { totalCount: 0 },
  // errorFosaUser: null,

  fetchingPreAuthData: false,
  fetchedPreAuthData: false,
  errorPreAuthData: null,
  PreAuthData: [],
  PreAuthDataPageInfo: { totalCount: 0 },

  fetchingPreAuthFormData: false,
  fetchedPreAuthFormData: false,
  errorPreAuthFormData: null,
  PreAuthFormData: [],
  PreAuthFormDataPageInfo: { totalCount: 0 },

  fetchingGetPreAuthData: false,
  fetchedGetPreAuthData: false,
  // errorPreAuthData: null,
  getPreAuthData: [],

  fetchingGetPreAuthHistoryData: false,
  fetchedGetPreAuthHistoryData: false,
  getPreAuthHistoryData: [],
  PreAuthHistoryPageInfo: { totalCount: 0 },
  errorPreAuthHistoryData: null,

  // Medical items reducers
  fetchingMedicalItemsTableData: false,
  fetchedMedicalItemsTableData: false,
  MedicalItemsTableData: [],
  MedicalItemsTableDataPageInfo: { totalCount: 0 },
  errorMedicalItemsTableData: null,

  // Medical services reducers
  fetchingMedicalServicesTableData: false,
  fetchedMedicalServicesTableData: false,
  MedicalServicesTableData: [],
  MedicalServicesTableDataPageInfo: { totalCount: 0 },
  errorMedicalServicesTableData: null,

  // Admin reducers
  fetchingAdminItems: false,
  fetchingAdminItem: false,
  fetchedAdminItems: false,
  fetchedAdminItem: false,
  editingAdmin: false,
  deletingAdmin: false,
  adminItems: [],
  adminItem: null,
  adminItemsPageInfo: { totalCount: 0 },
  errorAdminItems: null,
  errorEditAdmin: null,
  errorDeleteAdmin: null,
  createUpdateAdminSuccess: false,

  // specialty and positions
  fosaHealthFacilitySpecialtyItems: null,
  fosaHealthFacilityPositionItems: null,

  // Roles
  fetchingRoles: false,
  fetchedRoles: false,
  roles: [],
  errorRoles: null,

  claimChatMessages: [],
  loadingChat: false,
  chatError: null,
};

const fosaReducer = (state = initialState, action) => {
  switch (action.type) {
    // specialty and positions
    case "FETCH_FOSA_FACILITY_USER_SPECIALTIES":
      return {
        ...state,
        fosaHealthFacilitySpecialtyItems: parseData(
          action.payload.insureeSpecialities
        ),
      };
    case "FETCH_FOSA_FACILITY_USER_POSITIONS":
      return {
        ...state,
        fosaHealthFacilityPositionItems: parseData(
          action.payload.healthFacilityInsureePositions
        ),
      };
    // ROLES REDUCER
    case FETCH_ROLES_REQUEST:
      return {
        ...state,
        fetchingRoles: true,
        fetchedRoles: false,
        errorRoles: null,
      };

    case FETCH_ROLES_SUCCESS:
      return {
        ...state,
        fetchingRoles: false,
        fetchedRoles: true,
        roles: parseData(action.payload.role),
      };

    case FETCH_ROLES_FAILURE:
      return {
        ...state,
        fetchingRoles: false,
        errorRoles: formatGraphQLError(action.payload),
      };
    // FOSA MEDIAL ITEMS
    case FETCH_FOSA_MEDICAL_ITEMS_REQUEST:
      return {
        ...state,
        fetchingMedicalItems: true,
        fetchedMedicalItems: false,
        errorMedicalItems: null,
      };
    case FETCH_FOSA_MEDICAL_ITEMS_SUCCESS:
      return {
        ...state,
        fetchingMedicalItemsTableData: false,
        fetchedMedicalItemsTableData: true,
        MedicalItemsTableData: parseData(action.payload.medicalItemsData),
        MedicalItemsTableDataPageInfo: pageInfo(
          action.payload.medicalItemsData
        ),
      };
    case FETCH_FOSA_MEDICAL_ITEMS_FAILURE:
      return {
        ...state,
        fetchingMedicalItems: false,
        errorMedicalItems: formatGraphQLError(action.payload),
      };

    // FOSA MEDIAL SERVICES
    case FETCH_FOSA_MEDICAL_SERVICES_REQUEST:
      return {
        ...state,
        fetchingMedicalServices: true,
        fetchedMedicalServices: false,
        errorMedicalServices: null,
      };
    case FETCH_FOSA_MEDICAL_SERVICES_SUCCESS:
      return {
        ...state,
        fetchingMedicalServicesTableData: false,
        fetchedMedicalServicesTableData: true,
        MedicalServicesTableData: parseData(action.payload.medicalServicesData),
        MedicalServicesTableDataPageInfo: pageInfo(
          action.payload.medicalServicesData
        ),
      };
    case FETCH_FOSA_MEDICAL_SERVICES_FAILURE:
      return {
        ...state,
        fetchingMedicalServices: false,
        errorMedicalServices: formatGraphQLError(action.payload),
      };

    // ADMIN REDUCER
    case FETCH_ADMIN_TABLE_REQUEST:
      return {
        ...state,
        fetchingAdminItems: true,
        fetchedAdminItems: false,
        errorAdminItems: null,
        adminItem: null,
        createUpdateAdminSuccess: null,
        errorEditAdmin: null,
      };

    case FETCH_ADMIN_TABLE_SUCCESS:
      return {
        ...state,
        fetchingAdminItems: false,
        fetchedAdminItems: true,
        adminItems: parseData(action.payload.users),
        adminItemsPageInfo: pageInfo(action.payload.users),
        createUpdateAdminSuccess: null,
        errorEditAdmin: null,
      };
    case FETCH_ADMIN_TABLE_FAILURE:
      return {
        ...state,
        fetchingAdminItems: false,
        errorAdminItems: formatGraphQLError(action.payload),
        createUpdateAdminSuccess: null,
        errorEditAdmin: null,
      };
    case CREATE_ADMIN_REQUEST:
      return {
        ...state,
        createUpdateAdminSuccess: null,
        editingAdmin: true,
        errorEditAdmin: null,
      };
    case CREATE_ADMIN_SUCCESS:
      return {
        ...state,
        editingAdmin: false,
        createUpdateAdminSuccess: action.payload,
        errorEditAdmin: null,
      };
    case CREATE_ADMIN_FAILURE:
      return {
        ...state,
        createUpdateAdminSuccess: null,
        editingAdmin: false,
        errorEditAdmin: action.payload,
      };
    case FETCH_ADMIN_REQUEST:
      return {
        ...state,
        fetchingAdminItem: true,
        fetchedAdminItem: false,
        errorAdminItem: null,
        createUpdateAdminSuccess: null,
        errorEditAdmin: null,
      };
    case FETCH_ADMIN_SUCCESS:
      return {
        ...state,
        fetchingAdminItem: false,
        fetchedAdminItem: true,
        adminItem: action.payload.users?.edges[0]?.node,
        createUpdateAdminSuccess: null,
        errorEditAdmin: null,
      };
    case FETCH_ADMIN_FAILURE:
      return {
        ...state,
        fetchingAdminItem: false,
        errorAdminItem: formatGraphQLError(action.payload),
        createUpdateAdminSuccess: null,
        errorEditAdmin: null,
      };
    case EDIT_ADMIN_REQUEST:
      return {
        ...state,
        editingAdmin: true,
        errorEditAdmin: null,
        createUpdateAdminSuccess: null,
      };
    case EDIT_ADMIN_SUCCESS:
      return {
        ...state,
        editingAdmin: false,
        createUpdateAdminSuccess: action.payload,
        errorEditAdmin: null,
      };
    case EDIT_ADMIN_FAILURE:
      return {
        ...state,
        editingAdmin: false,
        errorEditAdmin: action.payload,
        createUpdateAdminSuccess: null,
      };
    case DELETE_ADMIN_REQUEST:
      return {
        ...state,
        deletingAdmin: true,
        errorDeleteAdmin: null,
      };
    case DELETE_ADMIN_SUCCESS:
      return {
        ...state,
        deletingAdmin: false,
        adminItem: action.payload.deleteUser,
      };
    case DELETE_ADMIN_FAILURE:
      return {
        ...state,
        deletingAdmin: false,
        errorDeleteAdmin: formatGraphQLError(action.payload),
      };

    // ADMIN REDUCER

    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        signUpResponseData: action.payload?.createPhPortalUser,
        fetchingSignUp: false,
        fetchedSignUp: true,
        errorSignUp: null,
      };
    case FETCH_VERIFICATION_DATA_SUCCESS:
      return {
        ...state,
        fetchingVerificationData: false,
        fetchedVerificationData: false,
        pickerVerificationInsurees: parseData(action.payload.insurees),
        pickerVerificationInsureesPageInfo: pageInfo(action?.payload?.insurees),
      };
    case FETCH_CLAIM_TABLE_SUCCESS:
      return {
        ...state,
        fetchingClaimTableData: false,
        fetchedClaimTableData: true,
        ClaimTableData: parseData(action?.payload?.claims),
        ClaimTableDataPageInfo: pageInfo(action?.payload?.claims),
        errorClaimTableData: formatGraphQLError(action.payload),
      };
    case FETCH_HEALTH_FACILITIES_SUCCESS:
      return {
        ...state,
        fetchingVerificationData: false,
        fetchedVerificationData: true,
        pickerHealthFacilityInsurees: parseData(
          action?.payload?.healthFacilities
        ),
      };
    case FETCH_CONVENTIONNEMENT_BY_HF_ID_SUCCESS:
      return {
        ...state,
        fetchingConventionnementData: false,
        fetchedConventionnementData: true,
        Conventionnement: parseData(action.payload.conventionnementByHf),
        errorConventionnement: formatGraphQLError(action.payload),
      };
    case FETCH_HEALTH_FACILITIES_PACKAGE_REQUEST:
      return {
        ...state,
        fetchingHealthFacilitiesPackageData: true,
        errorHealthFacilitiesPackageData: null,
      };
    case FETCH_HEALTH_FACILITIES_PACKAGE_SUCCESS:
      return {
        ...state,
        fetchingHealthFacilitiesPackageData: false,
        fetchedHealthFacilitiesPackageData: true,
        healthFacilitiesPackageData: parseData(action?.payload?.healthFacilities?.edges?.[0]?.node?.healthcarePackage?.actHealthcarePackageRelations || []),
        healthFacilityHealthSupport: action?.payload?.healthFacilities?.edges?.[0]?.node?.fosaLevel?.healthSupport ?? null,
        healthFacilitiesPackageDataPageInfo: pageInfo(action?.payload?.healthFacilities?.edges?.[0]?.node?.healthcarePackage?.actHealthcarePackageRelations || []),
        errorHealthFacilitiesPackageData: formatGraphQLError(action.payload),
      };
    case FETCH_HEALTH_FACILITIES_PACKAGE_FAILURE:
      return {
        ...state,
        fetchingHealthFacilitiesPackageData: false,
        fetchedHealthFacilitiesPackageData: false,
        errorHealthFacilitiesPackageData: action.payload,
      };
    case FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_REQUEST:
      return {
        ...state,
        fetchingHealthFacilitiesProductBundleData: true,
        errorHealthFacilitiesProductBundleData: null,
      };
    case FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_SUCCESS:
      return {
        ...state,
        fetchingHealthFacilitiesProductBundleData: false,
        fetchedHealthFacilitiesProductBundleData: true,
        healthFacilitiesProductBundleData: parseData(action?.payload?.healthFacilities?.edges?.[0]?.node?.healthcareProductBundle?.healthcareProductBundleProductRelations || []),
        healthFacilitiesProductBundleDataPageInfo: pageInfo(action?.payload?.healthFacilities?.edges?.[0]?.node?.healthcareProductBundle?.healthcareProductBundleProductRelations || []),
        errorHealthFacilitiesProductBundleData: formatGraphQLError(action.payload),
      };
    case FETCH_HEALTH_FACILITIES_PRODUCT_BUNDLE_FAILURE:
      return {
        ...state,
        fetchingHealthFacilitiesProductBundleData: false,
        fetchedHealthFacilitiesProductBundleData: false,
        errorHealthFacilitiesProductBundleData: action.payload,
      };
    case FETCH_VERIFICATION_CODE_SUCCESS:
      return {
        ...state,
        fetchingVerificationCode: false,
        fetchedVerificationCode: true,
        VerificationCode: parseData(action.payload.getVerificationHistory),
        errorVerificationCode: formatGraphQLError(action.payload),
      };
    case CLEAN_VERIFICATION_CODE:
      return {
        ...state,
        VerificationCode: [],
      };
    case FETCH_HEALTH_FACILITIES_INUSREE_SUCCESS:
      return {
        ...state,
        fetchingHfInsuree: false,
        fetchedHfInsuree: true,
        medicalInsureePageInfo: pageInfo(
          action.payload.getInsuresByHealthFacility
        ),
        HfInsuree: parseData(action.payload.getInsuresByHealthFacility),
        errorHfInsuree: formatGraphQLError(action.payload),
      };
    case FETCH_HEALTH_FACILITIES_INUSREE_STATUS_SUCCESS:
      return {
        ...state,
        fetchingHfInsureeStatus: false,
        fetchedHfInsureeStatus: true,
        HfInsureeStatus: action.payload.getFosaStatus,
        errorHfInsureeStatus: formatGraphQLError(action.payload),
      };
    case FETCH_HEALTH_FACILITIES_SUBSTITUTE_STATUS_SUCCESS:
      return {
        ...state,
        fetchingHfSubstituteStatus: false,
        fetchedHfSubstituteStatus: true,
        HfSubstituteStatus: action.payload.getFosaStatus,
        errorHfSubstituteStatus: formatGraphQLError(action.payload),
      };
    case FETCH_VERIFICATION_HISTORY_SUCCESS:
      return {
        ...state,
        fetchingVerificationHistory: false,
        fetchedVerificationHistory: true,
        verificationHistoryData: parseData(
          action.payload.getVerificationHistory
        ),
        verificationHistoryPageInfo: pageInfo(
          action.payload.getVerificationHistory
        ),
        errorVerificationHistory: formatGraphQLError(action.payload),
      };
    case FETCH_POLICIES_INSUREE_REQUEST:
      return {
        ...state,
        fetchingPolicies: true,
        fetchedPolicies: false,
        policies: null,
        policy: null,
        errorPolicies: null,
      };
    case FETCH_POLICIES_INSUREE_SUCCESS:
      return {
        ...state,
        fetchingPolicies: false,
        fetchedPolicies: true,
        policies: parseData(action.payload.policiesByInsuree),
        policiesPageInfo: pageInfo(action.payload.policiesByInsuree),
        errorPolicies: formatGraphQLError(action.payload),
      };
    case FETCH_POLICIES_INSUREE_FAILURE:
      return {
        ...state,
        fetchingPolicies: false,
        errorPolicies: formatServerError(action.payload),
      };
    case FETCH_LATEST_ACTIVE_INSUREE_REQUEST:
      return {
        ...state,
        fetchingPolicyValid: true,
        fetchedPolicyValid: false,
        policyValidData: null,
        errorPolicyValid: null,
      };
    case FETCH_LATEST_ACTIVE_INSUREE_SUCCESS:
      var validBy = action.payload.getLatestActiveInsureePolicy;
      console.log("validBy", validBy);
      return {
        ...state,
        fetchingPolicyValid: false,
        fetchedPolicyValid: true,
        policyValidData: action.payload.getLatestActiveInsureePolicy,
        errorPolicyValid: formatGraphQLError(action.payload),
      };
    case FETCH_LATEST_ACTIVE_INSUREE_FAILURE:
      return {
        ...state,
        fetchingPolicyValid: false,
        errorPolicyValid: formatServerError(action.payload),
      };
    case FETCH_GUARDIAN_SUCCESS:
      const guardians = [];
      if (action.payload?.insurees?.edges[0]?.node?.firstGuardian) {
        guardians.push(action.payload.insurees.edges[0].node.firstGuardian);
      }
      if (action.payload?.insurees?.edges[0]?.node?.secondGuardian) {
        guardians.push(action.payload.insurees.edges[0].node.secondGuardian);
      }
      return {
        ...state,
        fetchingGuardian: false,
        fetchedGuardian: true,
        guardianData: guardians,
        errorGuardian: formatGraphQLError(action.payload),
      };
    case FETCH_PRINT_CARE_SHEET_SUCCESS:
      return {
        ...state,
        fetchingCareSheet: false,
        fetchedCareSheet: true,
        careSheetData: action.payload?.camuCareSheet,
        errorCareSheet: formatGraphQLError(action.payload),
      };
    case CREATE_FOSA_USER_SUCCESS:
      return {
        ...state,
        createFosaUserData: action.payload,
        fetchingFosaUser: false,
        fetchedFosaUser: true,
        errorFosaUser: null,
      };
    case CLEAR_CARESHEET_DATA:
      return {
        ...state,
        careSheetData: null,
      };
    case FETCH_CLAIM_SERVICE_SUCCESS:
      return {
        ...state,
        fetchingClaimServices: false,
        fetchedClaimServices: true,
        ClaimServices: parseData(action.payload.insureeClaimService),
        errorClaimServices: formatGraphQLError(action.payload),
      };
    case FETCH_CLAIM_ITEMS_SUCCESS:
      console.log("action.payload", action.payload);
      return {
        ...state,
        fetchingClaimItems: false,
        fetchedClaimItems: true,
        ClaimItems: parseData(action.payload.insureeItemServiceFosa),
        errorClaimItems: formatGraphQLError(action.payload),
      };
    case FETCH_PATHOLOGY_SUCCESS:
      return {
        ...state,
        fetchingPathology: false,
        fetchedPathology: true,
        pathalogyList: parseData(action.payload.diagnosesStr),
        errorpathalogy1List: formatGraphQLError(action.payload),
      };
    case CORE_MUTATION_RESP:
      const mutations = parseData(action.payload.mutationLogs);
      return {
        ...state,
        fetchingMutations: false,
        mutations: _.unionBy(mutations, state.mutations, "clientMutationId"),
      };
    case FETCH_CLAIMBYID_SUCCESS:
      return {
        ...state,
        fetchingClaimById: false,
        fetchedClaimById: true,
        ClaimByIdData: action?.payload?.claim,
        errorClaimById: formatGraphQLError(action.payload),
      };
    case FETCH_CLAIMHISTORYBYID_SUCCESS:
      return {
        ...state,
        fetchingClaimHistoryById: false,
        fetchedClaimHistoryById: true,
        ClaimHistoryByIdData: action?.payload?.claimHistory,
        errorClaimHistoryById: formatGraphQLError(action.payload),
      };
    case CLEAR_CLAIM_RESP:
      return {
        ...state,
        ClaimByIdData: null,
      };
    case FETCH_ADMINID_SUCCESS:
      return {
        ...state,
        fetchingAdminId: false,
        fetchedAdminId: true,
        AdminIdData: parseData(action.payload.users),
        AdminIdPageInfo: pageInfo(action.payload.users),
        errorAdminId: formatGraphQLError(action.payload),
      };
    case FETCH_MEDICAL_INSUREE_SUCCESS:
      return {
        ...state,
        medicalInsureeResponseData: parseData(
          action.payload.policyHolderInsuree
        ),
        medicalInsureePageInfo: pageInfo(action.payload.policyHolderInsuree),
        fetchingMedicalInsuree: false,
        fetchedMedicalInsuree: true,
        errorMedicalInsuree: null,
      };
    case GET_CONSULTANT_SUCCESS:
      return {
        ...state,
        getConsultantData: parseData(action?.payload?.getConsultantHfInsuree),
        fetchingConsultantData: false,
        fetchedConsultantData: true,
        errorConsultantData: null,
        getConsultantDataPageInfo: pageInfo(
          action?.payload?.getConsultantHfInsuree
        ),
      };
    case FETCH_FOSA_USER_SUCCESS:
      return {
        ...state,
        fetchingFosaUser: false,
        fetchedFosaUser: true,
        fosaUserData: parseData(action.payload.users),
        fosaUserPageInfo: pageInfo(action.payload.users),
        errorFosaUser: formatGraphQLError(action.payload),
      };
    case FETCH_INSUREEUUID_SUCCESS:
      return {
        ...state,
        fetchingInsureeUuid: false,
        fetchedInsureeUuid: true,
        InsureeUuidData: parseData(action.payload.insurees),
        InsureeUuidPageInfo: pageInfo(action.payload.insurees),
        errorInsureeUuid: formatGraphQLError(action.payload),
      };
    case FETCH_SUBSTITUTE_SUCCESS:
      return {
        ...state,
        fetchingSubstitute: false,
        fetchedSubstitute: true,
        SubstituteData: parseData(action.payload.insurees),
        errorSubstitute: formatGraphQLError(action.payload),
      };
    case SUBMIT_CLAIM_SUCCESS:
      return {
        ...state,
        claimUpdate: action.payload,
        fetchingclaimUpdate: false,
        fetchedclaimUpdate: true,
        errorclaimUpdate: null,
      };
    case CREATE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        claimAttachments: action.payload,
        fetchingclaimAttachments: false,
        fetchedclaimAttachments: true,
        errorclaimAttachments: null,
      };
    case FETCH_ATTACHEMENTS_SUCCESS:
      return {
        ...state,
        fetchingAttachments: false,
        fetchedAttachments: true,
        AttachmentsData: parseData(action.payload.claimAttachments),
        AttachmentsPageInfo: pageInfo(action.payload.claimAttachments),
        errorAttachments: formatGraphQLError(action.payload),
      };

    case FETCH_PREAUTH_SUCCESS:
      return {
        ...state,
        fetchingPreAuthData: false,
        fetchedPreAuthData: true,
        PreAuthDataPageInfo: pageInfo(action.payload.preAuthorizations),
        PreAuthData: parseData(action.payload.preAuthorizations),
        errorPreAuthData: formatGraphQLError(action.payload),
      };

    case FETCH_PREAUTHFORM_SUCCESS:
      return {
        ...state,
        fetchingPreAuthFormData: false,
        fetchedPreAuthFormData: true,
        errorPreAuthFormData: null,
        PreAuthFormData: parseData(action.payload.preAuthorizations),
        PreAuthFormDataPageInfo: { totalCount: 0 },
      };

    case GET_PREAUTH_SUCCESS:
      return {
        ...state,
        fetchingGetPreAuthData: false,
        fetchedGetPreAuthData: true,
        getPreAuthData: parseData(action.payload.preAuthorizations),
        errorPreAuthData: formatGraphQLError(action.payload),
      };
    case FETCH_PREAUTH_HISTORY_SUCCESS:
      return {
        ...state,
        fetchingGetPreAuthHistoryData: false,
        fetchedGetPreAuthHistoryData: true,
        getPreAuthHistoryData: parseData(
          action.payload.preAuthorizationsHistory
        ),
        PreAuthHistoryPageInfo: pageInfo(
          action.payload.preAuthorizationsHistory
        ),
        errorPreAuthHistoryData: formatGraphQLError(action.payload),
      };

    case FETCH_CLAIM_CHAT_REQUEST:
      return {
        ...state,
        loadingChat: true,
        chatError: null,
      };
    case 'ADD_CHAT_MESSAGE':
        return {
          ...state,
          claimChatMessages: [
            ...state.claimChatMessages,
            action.payload
          ]
        };
    case FETCH_CLAIM_CHAT_SUCCESS:
      return {
        ...state,
        claimChatMessages: action.payload,
        loadingChat: false,
      };
    case FETCH_CLAIM_CHAT_FAILURE:
      return {
        ...state,
        loadingChat: false,
        chatError: action.payload,
      };

    default:
      return state;
  }
};

export default fosaReducer;
